import { MutationTree } from 'vuex';
import { IIntegration } from '@signing-page/integrations/types/integration';
import { IIntegrationState } from '@signing-page/integrations/store/integrations.store';

export const mutationSetStripe = 'setStripe';
export const mutationSetStripeError = 'setStripeError';

export const mutationSetAuthorizeNet = 'setAuthorizeNet';
export const mutationSetAuthorizeNetError = 'setAuthorizeNetError';

export const mutations: MutationTree<IIntegrationState> = {
  [mutationSetStripe](state: IIntegrationState, stripe: IIntegration) {
    state.stripe = stripe;
  },
  [mutationSetStripeError](state: IIntegrationState, error: string) {
    state.stripeError = error;
  },
  [mutationSetAuthorizeNet](state: IIntegrationState, authorizeNet: IIntegration) {
    state.authorizeNet = authorizeNet;
  },
  [mutationSetAuthorizeNetError](state: IIntegrationState, error: string) {
    state.authorizeNetError = error;
  },
};
